module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.support),
      expression: "!support"
    }],
    staticClass: "uploader-unsupport"
  }, [_vm._t("default", [_vm._m(0)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n      Your browser, unfortunately, is not supported by Uploader.js. The library requires support for "), _c('a', {
    attrs: {
      "href": "http://www.w3.org/TR/FileAPI/"
    }
  }, [_vm._v("the HTML5 File API")]), _vm._v(" along with "), _c('a', {
    attrs: {
      "href": "http://www.w3.org/TR/FileAPI/#normalization-of-params"
    }
  }, [_vm._v("file slicing")]), _vm._v(".\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05aa39f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/unsupport.vue
// module id = 72
// module chunks = 0